import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { FaUserCircle, FaCalendarAlt, FaSignOutAlt, FaChevronDown } from 'react-icons/fa';

export function Navbar() {
  const navigate = useNavigate();

  // 1. LocalStorage se userEmail nikal kar state mein set kiya
  const [userEmail, setUserEmail] = useState(localStorage.getItem('userEmail') || 'Guest User');

  const [selectedYear, setSelectedYear] = useState(
    localStorage.getItem('qurbani_year') || new Date().getFullYear().toString()
  );

  const years = ['2025', '2026'];

  const handleYearChange = (e) => {
    const newYear = e.target.value;
    setSelectedYear(newYear);
    localStorage.setItem('qurbani_year', newYear);
    window.location.reload();
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  return (
    <nav className="backdrop-blur-md  shadow-sm fixed top-0 right-0 left-64 z-30 border-b border-gray-100 px-8">
      <div className="max-w-full mx-auto">
        <div className="flex justify-between h-16 items-center">

          <div className="flex items-center gap-2">
            {/* Left side empty for now */}
          </div>

          <div className="flex items-center gap-6">

            {/* Year Selector */}
            <div className="flex items-center gap-3 bg-gray-50 border border-gray-200 pl-3 pr-1 py-1 rounded-xl hover:bg-gray-100 transition-all">
              <select
                value={selectedYear}
                onChange={handleYearChange}
                className="bg-transparent text-gray-800 text-sm font-extrabold outline-none cursor-pointer pr-4 appearance-none"
              >
                {years.map((year) => (
                  <option key={year} value={year}>{year}</option>
                ))}
              </select>
              <FaChevronDown className="text-gray-400 size-2.5 -ml-3 pointer-events-none" />
            </div>

            <div className="h-8 w-[1px] bg-gray-200"></div>

            {/* Profile Section */}
            <div className="group relative flex items-center gap-3 cursor-pointer">
              <div className="flex flex-col items-end mr-1">
                {/* 2. Email ka pehla part bold mein dikhayenge */}
                <span className="text-xs font-bold text-gray-100 leading-none truncate max-w-[120px]">
                  {userEmail.split('@')[0].toUpperCase()}
                </span>
                {/* 3. Poori email niche chote size mein */}
                <span className="text-[12px] text-indigo-50 font-black mt-1 truncate max-w-[150px]">
                  {userEmail}
                </span>
              </div>

              <div className="relative">
                <div className="w-10 h-10 bg-blue-50 border-2 border-blue-100 rounded-full flex items-center justify-center text-green-600 group-hover:bg-blue-600 group-hover:text-white transition-all shadow-sm">
                  <FaUserCircle size={28} className='text-blue-900' />
                </div>

                {/* Dropdown Menu */}
                <div className="absolute right-0 top-full pt-3 opacity-0 group-hover:opacity-100 pointer-events-none group-hover:pointer-events-auto transition-all transform translate-y-2 group-hover:translate-y-0">
                  <div className="w-48 bg-white border border-gray-100 shadow-2xl rounded-xl p-1.5 overflow-hidden">

                    <button
                      onClick={handleLogout}
                      className="w-full flex items-center gap-3 px-4 py-2.5 text-red-600 text-sm font-bold hover:bg-red-50 rounded-lg transition-colors"
                    >
                      <FaSignOutAlt className="text-red-500" />
                      Logout
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </nav>
  );
}